var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formChoice==='urban')?_c('Urban'):(_vm.formChoice==='nile_ug')?_c('NileUg'):_c('DefaultCreate')}
var staticRenderFns = []

export { render, staticRenderFns }